// extracted by mini-css-extract-plugin
module.exports = {"Default":"withNotification_Default__VLa8-","Body":"withNotification_Body__uNrRl"};